import Storage from './storage'
import API from './api'

export const storage = new Storage()
export const api = new API(storage)
